import type { FaireThemeEntity } from "../../entity_types/theme";

export const modern_minimalist_totes: FaireThemeEntity = {
  token: "modern-minimalist-totes",
  type: "theme",
  name: "Modern Minimalist Totes",
  description: "Sleek large-capacity bags balancing functionality with a clean, striped aesthetic for everyday durability.",
  teaser: "Expand your bag category with everyday totes your pop-up shoppers will grab.",
  detail: "You already have strong interest in crossbody bags for women and kids. These minimalist totes expand the handbag category with the clean, functional aesthetic that matches what's already in your cart.",
  bgColor: "#D4EBD4",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_u4mfrqc8ac",
    "p_9ff254ppdt",
    "p_bvq9phq2h5",
    "p_k9rpz8wyby",
    "p_m5f9ntrc42",
    "p_c8ygtk86qw",
    "p_kck7b89s3k",
    "p_td6sxyw8kb",
    "p_bam5masyah",
    "p_yqpd4fnyac",
    "p_2asezecnvg",
    "p_4w7a6pw4dz",
    "p_42n546c9et",
    "p_wydz8gtxew",
    "p_kwpste5e82",
    "p_ez7an982sq",
    "p_7zfmcchmgy",
    "p_prh33kaxss",
    "p_fr4jk43am9",
    "p_22q4vsqvc6",
    "p_gqgbru8pf6",
    "p_k8h3pn2zz2",
    "p_qj5mvsmf5g",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
